"use client";

import { AlertTriangle } from "lucide-react";
import { useRegionStore } from "@/store/index";

export function MaintenanceBanner() {
  const { isMaintenanceMode } = useRegionStore();

  if (!isMaintenanceMode) return null;

  return (
    <div className="bg-orange-50 border-l-4 border-orange-main p-4 mb-6 rounded-r-lg">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-orange-main shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold text-orange-800">
            Mantenimiento temporal
          </h3>
          <p className="text-sm text-orange-700 mt-1">
            La tienda se encuentra en mantenimiento momentáneo. Podrás seguir
            accediendo a tu perfil y pedidos, pero por ahora no hay productos
            disponibles. Vuelve a intentarlo más tarde.
          </p>
        </div>
      </div>
    </div>
  );
}
